import { useEffect, useState } from 'react';
import {
  botPlaybackBarCount,
  subscribeBotPlaybackLevels,
} from '../lib/botPlaybackMeter';

const N = botPlaybackBarCount();

/** Subtle bottom-right bars driven by remote bot track energy (not decorative). */
export function BotPlaybackBars({ active }: { active: boolean }) {
  const [levels, setLevels] = useState<number[]>(() => Array(N).fill(0));

  useEffect(() => {
    if (!active) {
      setLevels(Array(N).fill(0));
      return;
    }
    return subscribeBotPlaybackLevels(setLevels);
  }, [active]);

  if (!active) return null;

  const speaking = levels.some((v) => v > 0.06);

  return (
    <div
      className={`bot-playback-bars${speaking ? ' is-active' : ''}`}
      aria-hidden="true"
      title="Digital assistant audio level"
    >
      {levels.map((v, i) => (
        <span
          key={i}
          className="bot-playback-bar"
          style={{ transform: `scaleY(${Math.max(0.12, Math.min(1, v))})` }}
        />
      ))}
    </div>
  );
}
